import * as React from 'react';
import { OidcSecure, useOidc } from "@axa-fr/react-oidc";
import { Navigate } from 'react-router-dom'; 
import Helper from '../utilities/helper';

const Login = () => {
    const { isAuthenticated } = useOidc(); 
    
    React.useEffect(() => {
        if (isAuthenticated) {
            sessionStorage.setItem('signedIn', 'true');
        }
        else {
            sessionStorage.removeItem('signedIn');
        }
    });

    const previousPage = Helper.getPagePath();

    return (
        <OidcSecure>
            <Navigate to={previousPage} />
        </OidcSecure>
    );
};

export default Login;